package com.vizio.redwolf.dms

import com.vizio.redwolf.dms.model.NonceRegisterResponse
import com.vizio.redwolf.dms.model.NonceRequestResult
import com.vizio.redwolf.dms.model.NonceStatusResult
import com.vizio.redwolf.dms.model.PayNonceRequestResponse
import com.vizio.redwolf.dms.model.PayNonceStatusFieldedResponse
import com.vizio.redwolf.dms.model.PayNonceStatusResponse
import com.vizio.redwolf.dms.model.UnregisterAllResponse
import com.vizio.redwolf.dms.model.VoiceLinkingResponse
import kotlinx.serialization.json.Json
import kotlinx.serialization.modules.SerializersModule
import kotlinx.serialization.modules.polymorphic

object NonceJsonConfig {

    val config = Json {
        serializersModule = SerializersModule {
            polymorphic(NonceRequestResult::class) {
                subclass(NonceRequestResult.Pending::class, NonceRequestResult.Pending.serializer())
                subclass(NonceRequestResult.AlreadyRegistered::class, NonceRequestResult.AlreadyRegistered.serializer())
                defaultDeserializer { NonceRequestResult.Invalid.serializer() }
            }
            polymorphic(NonceStatusResult::class) {
                subclass(NonceStatusResult.Pending::class, NonceStatusResult.Pending.serializer())
                subclass(NonceStatusResult.Registered::class, NonceStatusResult.Registered.serializer())
                subclass(NonceStatusResult.NotExist::class, NonceStatusResult.NotExist.serializer())
                defaultDeserializer { NonceStatusResult.Invalid.serializer() }
            }
            polymorphic(PayNonceRequestResponse::class) {
                subclass(PayNonceRequestResponse.Pending::class, PayNonceRequestResponse.Pending.serializer())
                subclass(PayNonceRequestResponse.AlreadyRegistered::class, PayNonceRequestResponse.AlreadyRegistered.serializer())
                defaultDeserializer { PayNonceRequestResponse.Invalid.serializer() }
            }
            polymorphic(PayNonceStatusResponse::class) {
                subclass(PayNonceStatusResponse.Pending::class, PayNonceStatusResponse.Pending.serializer())
                subclass(PayNonceStatusResponse.Registered::class, PayNonceStatusResponse.Registered.serializer())
                subclass(PayNonceStatusResponse.NotExist::class, PayNonceStatusResponse.NotExist.serializer())
                defaultDeserializer { PayNonceStatusResponse.Invalid.serializer() }
            }
            polymorphic(PayNonceStatusFieldedResponse::class) {
                subclass(PayNonceStatusFieldedResponse.Pending::class, PayNonceStatusFieldedResponse.Pending.serializer())
                subclass(PayNonceStatusFieldedResponse.Registered::class, PayNonceStatusFieldedResponse.Registered.serializer())
                subclass(PayNonceStatusFieldedResponse.PinExpired::class, PayNonceStatusFieldedResponse.PinExpired.serializer())
                subclass(PayNonceStatusFieldedResponse.NotExist::class, PayNonceStatusFieldedResponse.NotExist.serializer())
                defaultDeserializer { PayNonceStatusFieldedResponse.Invalid.serializer() }
            }
            polymorphic(NonceRegisterResponse::class) {
                subclass(NonceRegisterResponse.RegistrationSuccess::class, NonceRegisterResponse.RegistrationSuccess.serializer())
                subclass(NonceRegisterResponse.InvalidAuth::class, NonceRegisterResponse.InvalidAuth.serializer())
                subclass(NonceRegisterResponse.Failed::class, NonceRegisterResponse.Failed.serializer())
                subclass(NonceRegisterResponse.DeviceNameMustBeUnique::class, NonceRegisterResponse.DeviceNameMustBeUnique.serializer())
                defaultDeserializer { NonceRegisterResponse.Invalid.serializer() }
            }
            polymorphic(UnregisterAllResponse::class) {
                subclass(UnregisterAllResponse.UnregistrationSuccess::class, UnregisterAllResponse.UnregistrationSuccess.serializer())
                subclass(UnregisterAllResponse.NoDevicesToUnregister::class, UnregisterAllResponse.NoDevicesToUnregister.serializer())
                defaultDeserializer { UnregisterAllResponse.Invalid.serializer() }
            }
            polymorphic(VoiceLinkingResponse::class) {
                subclass(VoiceLinkingResponse.Success::class, VoiceLinkingResponse.Success.serializer())
                defaultDeserializer { VoiceLinkingResponse.Failure.serializer() }
            }
        }
        coerceInputValues = true
        isLenient = true
        ignoreUnknownKeys = true
        encodeDefaults = true
        prettyPrint = true
        classDiscriminator = "responseCode"
    }

}